const buildGridFunc = ({
  list,
  obj,
  width,
  maxHeight,
  margin,
  hideAds = false,
  rtl = false,
}) => {
  /*
   ** function to get container aspect ratio icludes margin value
   */
  const getContainerAR = () =>
    (width - margin * (rowList.length + 1)) / maxHeight;

  const getImageRatio = (itemId) =>
    obj[itemId]?.ratio
      ? parseFloat(obj[itemId].ratio) < 0.6
        ? 0.6
        : parseFloat(obj[itemId].ratio) > 4
        ? 4
        : parseFloat(obj[itemId].ratio)
      : 1;

  /**
   * renderList - array | final result of all items with necessary sixes and styles positions
   * translateY - number | influencing on positionY of rows and items, updating on each row
   * translateX - number | influencing on positionX of items, refreshing in the end of each row
   * rowRatio - number | result of function getContainerAR, updating after each item, refreshing in the end of each row
   * sumImagesRatio - number | summ of aspect ratios of all images within one row, refreshing in the end of each row
   * filesInARow - number | quantity of files in a current row, updating on each file, refreshing in the end of each row
   * rowList - array | current list of files within one row, updating on each file, refreshing in the end of each row
   */

  const renderList = [];
  let translateY = 0;
  let translateX = margin;
  let rowRatio = 0;
  let sumImagesRatio = 0;
  let rowList = [];

  /**
   * doing loop through all incoming items
   */

  const renderArray = () => {
    if (hideAds) {
      return list;
    }
    const newArray = [...list];
    let position = 50;
    let interval = 75;
    while (position < newArray.length) {
      newArray.splice(position, 0, { ad: true });
      position += interval;
    }
    return newArray;
  };

  const newArray = renderArray();

  newArray.map((itemId, i) => {
    /**
     * imageRatio - calculate ratio of incoming image
     */
    const imageRatio = getImageRatio(itemId);

    /**
     * updting sumImagesRatio and rowList on each file
     */
    sumImagesRatio += imageRatio;

    rowList.push(itemId);

    /**
     * calculation new rowRatio when current file was added already to the rowList increased
     */
    rowRatio = getContainerAR();

    /**
     * checking if summ aspect ratio of images within current row is higher than rowRatio
     * or if this is the last element within the list
     * or if next or current item is folder-devider
     * if yes - this is the last item of current row and we have complete list
     */

    if (
      sumImagesRatio >= rowRatio || //summ aspect ratio of images within current row is higher than rowRatio
      i + 1 === newArray.length || //this is the last element within the list
      newArray[i + 1].folder || //next or current item is folder-devider
      itemId.folder
    ) {
      /**
       * newRowHeight - number, new height of the current row when its fill
       * if current item is folder-devider setting basic height of folder-devider - now its 80px
       * also checking case if this was the last item of the list or next item of the list is folder and summ aspect ration of images still less than rowRatio
       * in this case value will be equal to the maxHeight of row(320 px)
       */
      const newRowHeight = itemId.folder
        ? 80
        : (i + 1 === newArray.length || newArray[i + 1].folder) &&
          sumImagesRatio < rowRatio
        ? maxHeight
        : Math.floor((rowRatio / sumImagesRatio) * maxHeight);

      /**
       * doing loop through the items of current row
       */
      rowList.map((item, index) => {
        /**
         * imgAR - calculate ratio of incoming image
         */
        const imgAR = getImageRatio(item);

        /**
         * newWidth - calculate new width of item relevant to new height of the row
         * if its folder-devider width will be fuill width of container without margins
         */
        const newWidth = itemId.folder
          ? width - margin * (rowList.length + 1)
          : Math.round(imgAR * newRowHeight, -1);

        /**
         * pushing each item of current row with style property including all updated sizes and positions
         *
         * because css accepting only integer numbers the last items in different rows can be not setted in one line and it clealry visible, cos its supose to be one line
         * - so here is doing check if this is the last item within current row and this row is full or next item is folder devider
         * - doing positioning of item relevant to the end of row, so we will have little bit different distance from previous item, but within grid noone will see it
         */

        const currentXPosition =
          index + 1 === rowList.length &&
          i + 1 !== newArray.length &&
          !newArray[i + 1].folder
            ? width - newWidth - margin
            : translateX;

        const objId = item.folder
          ? "folder" + item.folder
          : item.ad
          ? "ad" + i
          : item;

        renderList.push({
          ...obj[item],
          id: objId,
          posY: translateY,
          style: {
            width: parseInt(newWidth),
            height: parseInt(newRowHeight),
            transform: `translate3d(${
              (rtl ? -1 : 1) * currentXPosition
            }px, ${translateY}px, 0px)`,
            // transition: "none 0s ease 0s",
          },
        });

        /**
         * updating current x-position to know where to put next item of this row
         */
        translateX += newWidth + margin;
      });

      /**
       * refreshing all values relevant to the row
       *
       * updating Y-position value cos its influencing on the next row if item is folder-devider adding external space
       */
      rowList = [];
      rowRatio = 0;
      translateX = margin;
      sumImagesRatio = 0;
      translateY += parseInt(newRowHeight) + margin + (itemId.folder ? 20 : 0);
    }
  });

  return { renderList, containerHeight: translateY };
};

export default buildGridFunc;
